// extracted by mini-css-extract-plugin
module.exports = {"working":"WorkingIndicator_working__3WZUm","dot":"WorkingIndicator_dot__2KG5_","bounce":"WorkingIndicator_bounce__1oEaI","label":"WorkingIndicator_label__2C7XE"};